module.exports = __webpack_public_path__ + "img/Group4_26_english.2558c2f8.jpg";